var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.77,
    height: 21.55,
    viewBox: "0 0 21.77 21.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-search2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.2,10.9A10.2,10.2,0,1,1,11.4,21.1,10.24,10.24,0,0,1,1.2,10.9Zm1.5,0a8.8,8.8,0,1,0,8.8-8.8A8.81,8.81,0,0,0,2.7,10.9Z",
    transform: "translate(-1.15 -0.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,21.9l-2-2a.78.78,0,0,1,1.1-1.1l2,2a.78.78,0,0,1,0,1.1.76.76,0,0,1-.5.2C21.9,22.1,21.6,22.1,21.5,21.9Z",
    transform: "translate(-1.15 -0.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_43",
    "data-name": "Capa 43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6,10.2h-.1A3.5,3.5,0,0,1,8.1,6.8a3.37,3.37,0,0,1,3.4-3.4A3.46,3.46,0,0,1,15,6.8a3.5,3.5,0,0,1-3.4,3.4ZM9.1,6.8a2.35,2.35,0,0,0,2.3,2.4h.2A2.37,2.37,0,0,0,14,6.8a2.43,2.43,0,0,0-2.4-2.4A2.39,2.39,0,0,0,9.1,6.8Z",
    transform: "translate(-1.15 -0.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.65,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,16.6a2.78,2.78,0,0,1-1.4-2.3,3.08,3.08,0,0,1,1.4-2.4,7.13,7.13,0,0,1,7.2,0,2.78,2.78,0,0,1,1.4,2.3,3.08,3.08,0,0,1-1.4,2.4,6.3,6.3,0,0,1-3.6,1A6.3,6.3,0,0,1,8.1,16.6Zm-.4-2.3a1.68,1.68,0,0,0,1,1.5,6,6,0,0,0,6.1,0,2,2,0,0,0,1-1.5,1.68,1.68,0,0,0-1-1.5,6,6,0,0,0-6.1,0A1.68,1.68,0,0,0,7.7,14.3Z",
    transform: "translate(-1.15 -0.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.59,
    fillRule: "evenodd"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.15 -0.65)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSearch2);
export default __webpack_public_path__ + "static/media/user-search2.8b50c64a666d46473b5a5fce678c02d9.svg";
export { ForwardRef as ReactComponent };